export default __webpack_public_path__ + "static/media/no_chats.0200ac14.svg";